import React, { useContext, useMemo } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { aggregateData } from '../functions';
import GraphTable from '../mechanisms/graphtable';
import { formatCurrency } from '../functions';
import { currencyPrefix } from '../single-card';
import { DashboardContext } from '../mechanisms/card';
import DashView from '../mechanisms/dashview';
import { convert_seconds } from '../../Dash/HistoricDash/graphs/charts';

const LostOpportunitiesDashboard = ({ data }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => aggregateData('value', data.filter(d => d.status === 'LOST'), 'owner_id'), [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'owner_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor Perdido', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                }
            ]} />
                : <DashView name='lostopportunities' rows={graph} vx={'owner_name'} vy={['value', 'count']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    else if (vy === 'duration')
                        return convert_seconds(row[vy]/(row.count || 1))
                    return row[vy]
                }} />
            }
        </>
    );
}


export default LostOpportunitiesDashboard